/**
 * @author Brendan Magee
 * @desc Container component for plans list
 * @example <plans-list-container $state="$state"
 *                                filters-service="filtersService"
 *                                platform-service="platformService"
 *                                site-service="siteService"
 *                                hierarchy="company.siteServiceHierarchy"
 *                                platforms="platforms"
 *                                websites="websites">
 *          </plans-list-container>
 */

import template from './plans.list.html';

class PlansListContainerController {
  constructor(siteService) {
    this.siteService = siteService;
  }

  $onInit() {
    this.selectedWebsite = this.siteService.getSelectedWebsite();
    if (this.selectedWebsite) {
      this.hierarchy = this.getHierarchy(this.selectedWebsite._id);
    } else {
      this.siteService.getDefaultWebsite()
        .then((website) => {
          this.hierarchy = this.getHierarchy(website._id);
        });
    }


    this.defaultFilters = this.filtersService.defaultFilters || null;

    this.filterSet = this.filtersService.createFilterSetFromUrl();

    if (this.selectedWebsite) {
      this.getSections(this.selectedWebsite._id);
      this.getWebsitePlatforms(this.selectedWebsite._id);

      this.filterSet.getFilter('hierarchy').changeValue(this.selectedWebsite._id);
      this.filterSet.getFilter('websites').changeValue(this.selectedWebsite._id);
    } else {
      this.siteService.getDefaultWebsite().then((res) => {
        this.selectedWebsite = res;
        this.missingData.selectedWebsite = false;

        this.getSections(this.selectedWebsite._id);
        this.getWebsitePlatforms(this.selectedWebsite._id);
      });
    }

    this.missingData = {
      selectedWebsite: !this.selectedWebsite,
      websites: !this.websites
    };
  }

  getHierarchy(id) {
    const selecteWebsiteHierarchy = this.websiteHierarchies.find(config =>
      config.website === id);
    return selecteWebsiteHierarchy ? selecteWebsiteHierarchy.hierarchy : null;
  }

  getWebsitePlatforms(websiteId) {
    this.websitePlatforms = this.platformService.getPlatformsByWebsiteId(websiteId);
  }

  getSections(id) {
    this.loadingSections = true;
    this.siteService.getNavigation(id, { hierarchy: this.hierarchy })
      .then((response) => {
        this.sections = response.children;
        this.missingData.sections = false;
      }, () => {
        this.missingData.sections = true;
      })
      .finally(() => {
        this.loadingSections = false;
      });
  }

  onSelectWebsite(id) {
    this.hierarchy = this.getHierarchy(id);
    const match = this.siteService.cache.websites.find(site => site._id === id);
    this.selectedWebsite = this.siteService.setSelectedWebsite(match);

    if (this.selectedWebsite) {
      this.getSections(id);
      this.getWebsitePlatforms(id);

      this.filterSet.getFilter('hierarchy').changeValue(id);
      this.filterSet.getFilter('websites').changeValue(id);
    } else {
      this.missingData.selectedWebsite = true;
    }
  }
}

PlansListContainerController.$inject = ['siteService', 'featureFlag'];

const plansListContainer = {
  template,
  bindings: {
    $state: '<',
    filtersService: '<',
    platformService: '<',
    siteService: '<',
    websiteHierarchies: '<',
    platforms: '<',
    websites: '<'
  },
  controller: 'PlansListContainerController'
};

export default function (ngModule) {
  ngModule.component('plansListContainer', plansListContainer);
  ngModule.controller('PlansListContainerController', PlansListContainerController);
}
